import { NodeViewWrapper as TipTapNodeViewWrapper } from '@tiptap/react';
import styled from 'styled-components';

import { Button } from '@xing-com/button';
import { mediaConfined } from '@xing-com/layout-tokens';
import { SkeletonImage } from '@xing-com/skeleton';
import { scale330, scale380, spaceM } from '@xing-com/tokens';

type NodeViewWrapperProps = {
  loaded: boolean;
};

const NodeViewWrapper = styled(TipTapNodeViewWrapper)<NodeViewWrapperProps>`
  position: relative;

  img {
    ${(props) =>
      props.loaded
        ? ``
        : `
      display: none !important;
    `}
  }
`;

const ExcludeButton = styled(Button)`
  position: absolute;
  right: ${spaceM};
  top: ${spaceM};
`;

const ImageSkeletonContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`;

const ImageSkeleton = styled(SkeletonImage)`
  height: ${scale330};
  width: 80%;

  @media ${mediaConfined} {
    height: ${scale380};
  }
`;

export const Styled = {
  NodeViewWrapper,
  ExcludeButton,
  ImageSkeletonContainer,
  ImageSkeleton,
};
